import { CaretRightIcon } from '@phosphor-icons/react/dist/ssr';

// Icons + badge colors copied 1:1 from webflow.innovaccer.com's Solutions > Industries cards.
const ProviderIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H39C41.2091 0 43 1.79086 43 4V39C43 41.2091 41.2091 43 39 43H4C1.79086 43 0 41.2091 0 39V4Z" fill="#053BEE"/>
    <path d="M20.8652 30.0078C20.8652 30.0078 11.1152 24.7578 11.1152 18.5703C11.1152 17.2277 11.6486 15.94 12.598 14.9906C13.5474 14.0412 14.8351 13.5078 16.1777 13.5078C18.2955 13.5078 20.1096 14.6619 20.8652 16.5078C21.6209 14.6619 23.4349 13.5078 25.5527 13.5078C26.8954 13.5078 28.1831 14.0412 29.1325 14.9906C30.0819 15.94 30.6152 17.2277 30.6152 18.5703C30.6152 24.7578 20.8652 30.0078 20.8652 30.0078Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const PayerIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H39C41.2091 0 43 1.79086 43 4V39C43 41.2091 41.2091 43 39 43H4C1.79086 43 0 41.2091 0 39V4Z" fill="#AAD097"/>
    <path d="M16.7998 23.6348H28.7998C28.9987 23.6348 29.1895 23.5557 29.3301 23.4151C29.4708 23.2744 29.5498 23.0837 29.5498 22.8848V13.1348C29.5498 12.9359 29.4708 12.7451 29.3301 12.6044C29.1895 12.4638 28.9987 12.3848 28.7998 12.3848H18.2998C18.1009 12.3848 17.9101 12.4638 17.7695 12.6044C17.6288 12.7451 17.5498 12.9359 17.5498 13.1348V13.8848" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M25.7998 17.6348H13.7998C13.6009 17.6348 13.4101 17.7138 13.2695 17.8544C13.1288 17.9951 13.0498 18.1859 13.0498 18.3848V28.1348C13.0498 28.3337 13.1288 28.5244 13.2695 28.6651C13.4101 28.8057 13.6009 28.8848 13.7998 28.8848H24.2998C24.4987 28.8848 24.6895 28.8057 24.8301 28.6651C24.9708 28.5244 25.0498 28.3337 25.0498 28.1348V27.3848" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23.5498 19.8848L25.7998 17.6348L23.5498 15.3848" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const PublicSectorIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H39C41.2091 0 43 1.79086 43 4V39C43 41.2091 41.2091 43 39 43H4C1.79086 43 0 41.2091 0 39V4Z" fill="#FFADD9"/>
    <path d="M17.416 23.3167C20.1084 23.3167 22.291 21.134 22.291 18.4417C22.291 15.7493 20.1084 13.5667 17.416 13.5667C14.7236 13.5667 12.541 15.7493 12.541 18.4417C12.541 21.134 14.7236 23.3167 17.416 23.3167Z" stroke="#000A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.5 27.0667C11.2491 25.9148 12.2741 24.9683 13.4819 24.3131C14.6896 23.6579 16.0419 23.3147 17.4159 23.3147C18.79 23.3147 20.1423 23.6579 21.35 24.3131C22.5578 24.9683 23.5827 25.9148 24.3319 27.0667" stroke="#000A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M25.666 23.3167C27.04 23.3158 28.3924 23.6585 29.6002 24.3134C30.808 24.9683 31.833 25.9148 32.582 27.0667" stroke="#000A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23.8555 13.9135C24.5223 13.6476 25.2397 13.5322 25.9563 13.5756C26.673 13.619 27.3712 13.8202 28.001 14.1647C28.6309 14.5093 29.1769 14.9887 29.6 15.5687C30.0231 16.1487 30.3128 16.815 30.4486 17.52C30.5843 18.225 30.5626 18.9513 30.3851 19.647C30.2076 20.3426 29.8787 20.9905 29.4217 21.5442C28.9648 22.098 28.3912 22.544 27.7419 22.8504C27.0927 23.1568 26.3837 23.316 25.6658 23.3166" stroke="#000A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const LifeSciencesIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4C0 1.79086 1.79086 0 4 0H39C41.2091 0 43 1.79086 43 4V39C43 41.2091 41.2091 43 39 43H4C1.79086 43 0 41.2091 0 39V4Z" fill="#EB5324"/>
    <path d="M12.75 16H29.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.75 22H19.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.75 28H21" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M26.25 26.5C27.9069 26.5 29.25 25.1569 29.25 23.5C29.25 21.8431 27.9069 20.5 26.25 20.5C24.5931 20.5 23.25 21.8431 23.25 23.5C23.25 25.1569 24.5931 26.5 26.25 26.5Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M28.3711 25.6216L30.7495 28" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PRODUCT_ICONS: Record<string, string> = {
  Gravity:     'https://storage.googleapis.com/cms_rewire/product-icons/logo-gravity.svg',
  Flow:        'https://storage.googleapis.com/cms_rewire/product-icons/logo-flow.svg',
  Atlas:       'https://storage.googleapis.com/cms_rewire/product-icons/logo-atlas.svg',
  Galaxy:      'https://storage.googleapis.com/cms_rewire/product-icons/logo-galaxy.svg',
  Comet:       'https://storage.googleapis.com/cms_rewire/product-icons/logo-comet.svg',
  PQS:         'https://storage.googleapis.com/cms_rewire/product-icons/logo-pqs.svg',
  Cured:       'https://storage.googleapis.com/cms_rewire/product-icons/logo-cured.svg',
  StoryHealth: 'https://storage.googleapis.com/cms_rewire/product-icons/logo-storyhealth.svg',
  Humbi:       'https://storage.googleapis.com/cms_rewire/product-icons/logo-humbi.svg',
};

export const INDUSTRIES = [
  { label: 'Provider',      icon: ProviderIcon,      href: 'https://innovaccer.com/solutions/provider' },
  { label: 'Payer',         icon: PayerIcon,         href: 'https://innovaccer.com/solutions/payer' },
  { label: 'Public Sector', icon: PublicSectorIcon,  href: 'https://innovaccer.com/solutions/government' },
  { label: 'Life Sciences', icon: LifeSciencesIcon,  href: 'https://innovaccer.com/solutions/life-sciences' },
];

// Taglines carry a hard line break at the same point as innovaccer.com's <br/> —
// the tagline is `white-space: pre` so it never re-wraps while its width animates
// in on hover, which previously caused a jarring 3-line -> 2-line reflow.
export const PRODUCTS: Array<{ name: string; tagline: string; href: string }> = [
  { name: 'Gravity',     tagline: 'Autonomous\nHealthcare Platform',    href: 'https://get-gravity.ai' },
  { name: 'Flow',        tagline: 'AI-Powered\nEnd-to-End RCM',         href: 'https://go-flow.ai' },
  { name: 'Atlas',       tagline: 'Population Health\nOperating System', href: 'https://innovaccer.com/atlas' },
  { name: 'Galaxy',      tagline: 'AI-Powered Payer\nRisk and Quality',  href: 'https://get-galaxy.ai' },
  { name: 'Comet',       tagline: 'AI-Powered\nAccess Center',           href: 'https://comethealth.ai' },
  { name: 'PQS',         tagline: 'Pharmacy Quality\nand Performance',   href: 'https://www.pharmacyquality.com/' },
  { name: 'Cured',       tagline: 'AI-Powered\nHealthcare Marketing',    href: 'https://www.cured.health/' },
  { name: 'StoryHealth', tagline: 'Managed Specialty\nCare',             href: 'https://www.storyhealth.com/' },
  { name: 'Humbi',       tagline: 'Actuarial Intelligence',             href: 'https://humbi.ai' },
];

// 3 columns x 4 rows, matching webflow.innovaccer.com's Solutions > Teams grid exactly
// ("Infusion Center", not "Contact Center" — that label isn't on the live site at all).
export const TEAMS: Array<Array<{ label: string; href: string }>> = [
  [
    { label: 'Actuarial Intelligence', href: 'https://www.humbi.ai/' },
    { label: 'Value based care',       href: 'https://innovaccer.com/value-based-care' },
    { label: 'Population Health',      href: 'https://innovaccer.com/solutions/population-health' },
    { label: 'Care Management',        href: 'https://innovaccer.com/products/care-management' },
  ],
  [
    { label: 'Financial Performance',  href: 'https://go-flow.ai/' },
    { label: 'Referral Management',    href: 'https://innovaccer.com/ai-referral-management' },
    { label: 'CMS Access',             href: 'https://innovaccer.com/cms-access' },
    { label: 'Readmission Management', href: 'https://innovaccer.com/solutions/readmission-management' },
  ],
  [
    { label: 'Outreach and Experience',       href: 'https://innovaccer.com/solutions/marketing' },
    { label: 'Infusion Center',               href: 'https://innovaccer.com/solutions/infusion' },
    { label: 'Specialty Pharmacy',            href: 'https://innovaccer.com/solutions/specialty-pharmacy' },
    { label: 'Rural Health Transformation',   href: 'https://innovaccer.com/solutions/rural-health-transformation' },
  ],
];

interface NavDropdownSolutionsProps {
  className?: string;
}

export default function NavDropdownSolutions({ className = '' }: NavDropdownSolutionsProps) {
  return (
    <div className={`nav-dropdown${className ? ` ${className}` : ''}`}>
      <div className="nav-dropdown__body">

        {/* Industries */}
        <div className="nav-dropdown__section">
          <p className="nav-dropdown__section-label">Industries</p>
          <div className="nav-dropdown__industry-grid">
            {INDUSTRIES.map(({ label, icon: Icon, href }) => (
              <a key={label} href={href} className="nav-dropdown__industry-card">
                <div className="nav-dropdown__industry-card__inner">
                  <div className="nav-dropdown__industry-icon" style={{ background: 'transparent' }}>
                    <Icon />
                  </div>
                  <span className="nav-dropdown__industry-label">{label}</span>
                </div>
                <CaretRightIcon size={12} weight="bold" style={{ color: 'var(--seasons-color-text-tertiary)', flexShrink: 0 }} />
              </a>
            ))}
          </div>
        </div>

        {/* Solutions */}
        <div className="nav-dropdown__section">
          <p className="nav-dropdown__section-label">Solutions</p>
          <div className="nav-dropdown__product-grid">
            {PRODUCTS.map(({ name, tagline, href }) => (
              <a key={name} href={href} className="nav-dropdown__product-card">
                <div className="nav-dropdown__product-inner">
                  <div className="nav-dropdown__product-icon">
                    <img src={PRODUCT_ICONS[name]} alt={name} width={40} height={40} />
                  </div>
                  <span className="nav-dropdown__product-label">{name}</span>
                </div>
                <span className="nav-dropdown__product-tagline">{tagline}</span>
              </a>
            ))}
          </div>
        </div>

        {/* Teams */}
        <div className="nav-dropdown__section">
          <p className="nav-dropdown__section-label">Teams</p>
          <div className="nav-dropdown__team-grid">
            {TEAMS.map((col, ci) => (
              <div key={ci} className="nav-dropdown__team-col">
                {col.map(({ label, href }) => (
                  <a key={label} href={href} className="nav-dropdown__team-item">
                    <span className="nav-dropdown__team-label">{label}</span>
                    <CaretRightIcon size={12} weight="bold" style={{ color: 'var(--seasons-color-text-tertiary)', flexShrink: 0 }} />
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
